import { HttpClient } from "@angular/common/http";
import { environment } from "#environments/environment";
import { Injectable } from "@angular/core";
import { Activity } from "#models/activities/activity.model";

import { Observable } from "rxjs";
import { UntypedFormGroup } from "@angular/forms";
import { Equipment } from "#models/equipment.model";
import { WorklistQuickEstimate } from "#models/event/worklist-quick-estimate";

@Injectable()
export class WorklistItemQuickEstimateService {
  form: UntypedFormGroup;
  filterForm: UntypedFormGroup;
  constructor(private http: HttpClient) {}

  getQuickEstimateWithActivities(
    ID: number,
    worklistItemID: number
  ): Observable<WorklistQuickEstimate> {
    return this.http.get<WorklistQuickEstimate>(
      `${environment.apiEndpoint}/worklist-item-quickEstimates/${ID}/worklist-item/${worklistItemID}`,
      {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      }
    );
  }

  getByWorkListItemQuickEstimateById(
    worklistItemID: number
  ): Observable<IWorklistItemQuickEstimate[]> {
    return this.http.get<IWorklistItemQuickEstimate[]>(
      `${environment.apiEndpoint}/worklist-item-quickEstimates/GetByWorkListItemId?worklistItemID=${worklistItemID}`,
      {
        headers: {
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      }
    );
  }

  getByWorkListItemId(
    worklistItemId: number
  ): Observable<IWorklistItemQuickEstimate[]> {
    return this.http.get<IWorklistItemQuickEstimate[]>(
      `${environment.apiEndpoint}/worklist-item-quickEstimates/GetByWorkListItemId?itemId=${worklistItemId}`
    );
  }

  createQuickEstimateWithActivities(
    itemId: number,
    jobEstimateName: string,
    payload: Activity[]
  ) {
    return this.http.post<Activity>(
      `${environment.apiEndpoint}/worklist-item-quickEstimates/${itemId}/Create_AddCustomActivities?jobEstimateName=${jobEstimateName}`,
      payload
    );
  }

  editQuickEstimateWithActivities(
    itemId: number,
    jobEstimateName: string,
    payload: Activity[]
  ) {
    return this.http.put<Activity>(
      `${environment.apiEndpoint}/worklist-item-quickEstimates/${itemId}/Update_AddCustomActivities?jobEstimateName=${jobEstimateName}`,
      payload
    );
  }

  deleteCustomActivity(quickEstimateId: number, activityId: number) {
    return this.http.delete<WorklistQuickEstimate>(
      `${environment.apiEndpoint}/worklist-item-quickEstimates/${quickEstimateId}/activities/${activityId}`
    );
  }

  deleteWorklistItemQuickEstimate(ID: number) {
    return this.http.delete<void>(
      `${environment.apiEndpoint}/worklist-item-quickEstimates?quickEstimateId=${ID}`
    );
  }
}

export interface IAttachment {
  CreatedDate: string;
  FileName: string;
  FilePath: string;
  FileType: string;
  Extension: string;
}

export interface IWorklistItemQuickEstimate {
  WorklistItemID: number;
  JobEstimateName: string;
  EarlyEstimateStatus: number;
  DetailedEstimateStatus: number;
  EarlyEstimateCost: number;
  DetailedEstimateCost: number;
  SnapshottedActivities: number;
  SnapshottedManHours: number;
  SnapshottedDuration: number;
  SnapshottedCrewSize: number;
  SnapshottedDate: string;
  ProductivityCalendarTemplate: number;
  AssignedSchedulerTemplate: number;
  ID: number;
}

export interface IWorklistItem {
  DowntimeID;
  Name: string;
  DecisionStatus: string;
  DetailedTAScopeDescription: string;
  EquipmentID: number;
  Equipment: Equipment;
  ID: number;
}
